import { useEffect, useState } from 'react';

import { secondsLeft } from './scoreboard';

const TICK_MS = 250; // often enough for the second to change on every device together
export const OVER_MS = 5000; // how long the clock blinks at 00:00 once the time is up

const isOver = (timer, now) => Boolean(timer) && now >= timer.endsAt && now < timer.endsAt + OVER_MS;

/**
 * The timer of the scoreboard, ticking: the whole seconds left, whether it is running and
 * whether it has just run out on its own. A timer the panel ended is no timer at all, so
 * that one goes straight to 00:00 without the blinking.
 */
const useCountdown = (timer) => {
  const [seconds, setSeconds] = useState(() => secondsLeft(timer));
  const [over, setOver] = useState(() => isOver(timer, Date.now()));

  useEffect(() => {
    // The same value again does not render, so the scoreboard only redraws when a second goes by
    const tick = () => {
      const now = Date.now();
      setSeconds(secondsLeft(timer, now));
      setOver(isOver(timer, now));
      return Boolean(timer) && now < timer.endsAt + OVER_MS; // whether there is anything left to count
    };
    if (!tick()) return undefined;
    const interval = setInterval(() => {
      if (!tick()) clearInterval(interval);
    }, TICK_MS);
    return () => clearInterval(interval);
  }, [timer]);

  return { seconds, running: seconds > 0, over };
};

export default useCountdown;
